import { Client } from "@/Common/Api/Client";
import { LicencedIntervenor } from "@/Common/Api/MedfarDictionaries/Dto/Responses/LicencedIntervenor";
import { LicenceOrganisationRule } from "@/Common/Api/MedfarDictionaries/Dto/Responses/LicenceOrganisationRule";
import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import ButtonGroup from "@/Common/Components/Buttons/ButtonGroup";
import { ErrorMessageComponent } from "@/Common/Components/Errors/ErrorMessageComponent";
import { FeatureFlagControl } from "@/Common/Components/FeatureFlagControl";
import { InformationLoadingComponent } from "@/Common/Components/Loader/InformationLoadingComponent";
import { ReferalDoctorSearchAutocompleteCustom } from "@/Common/Components/Search/ReferalDoctorSearchAutocompleteCustom";
import { IReferralDoctorModel } from "@/Common/Models/IReferralDoctorModel";
import { TitleAndSpecialtyModel } from "@/Common/Models/MedfarDictionaries/TitleAndSpecialtyModel";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { DirectoryEntityType } from "@/ContactDirectory/Api/medfar-contactdirectory/dist";
import { FaxDirectorySearchComponent } from "@/ContactDirectory/Components/Search/FaxDirectorySearchComponent";
import { DirectoryHealthCareProvider } from "@/ContactDirectory/Models/DirectoryHealthCareProvider";
import { cacheStore } from "@/Globals/Stores/CacheStore";

interface ICreateNewEmployeeComponentProps {
    closePopupOperation: number;
    createClinicalAccountOperation: number;
    createClericalAccountOperation: number;
}

class CreateNewEmployeeComponentState {
    public isLoading: boolean;
    public errors: string[];
    public searchTerm: string = "";
    public licencedIntervenorInfo: IReferralDoctorModel;
    public intervenorTitleAndSpecialty: TitleAndSpecialtyModel;
}

class CreateNewEmployeeComponent extends BaseReactComponent<ICreateNewEmployeeComponentProps, CreateNewEmployeeComponentState> {
    constructor(props: ICreateNewEmployeeComponentProps) {
        super(props);

        this.state = new CreateNewEmployeeComponentState();
    }

    public componentDidMount(): void {
        $(window).trigger("resize");
        sessionStore.showGlobalOverlay(true);
    }

    public componentWillUnmount(): void {
        sessionStore.hideGlobalOverlay();
    }

    public componentDidUpdate(): void {
        $(window).trigger("resize");
    }

    public render(): JSX.Element {
        return (
            <div>
                <div className="p-body">
                    <div className="flex-container flex-column flex-start" style={{ "minHeight": "400px" }}>

                        <div>
                            <strong>
                                {cacheStore.GetString("UseSearchLabel")}.
                            </strong>
                        </div>

                        <div className="flex-container flex-row flex-start pad-top-10">
                            <div className="text-vcentered">{cacheStore.GetString("SearchDirectoryLabel")}: </div>
                            <div className="flex-grow-1 pad-left-15">
                                <FeatureFlagControl
                                    flag={cacheStore.ClinicSettings.EnableContactDirectory}
                                    activeFeature={(
                                        <FaxDirectorySearchComponent
                                            entityTypes={[DirectoryEntityType.HealthcareProvider]}
                                            onItemSelected={item => {
                                                const healthCareProvider = item.entity as DirectoryHealthCareProvider;
                                                const specialty = cacheStore.TitlesAndSpecialtiesCache
                                                    .filter(x => x.Model.licenceOrganisationRuleModel.Id === healthCareProvider.licenseOrganizationRuleId)
                                                    .toArray()
                                                    .firstPreferredOrDefault(p => p.Model.licenceOrganisationSpecialisationModel.Id === healthCareProvider.licenseOrganizationSpecializationId)
                                                    ?.Model;
                                                this.mutateState(s => {
                                                    s.licencedIntervenorInfo = DirectoryHealthCareProvider.toReferralDoctorModel(item.entity as DirectoryHealthCareProvider);
                                                    s.intervenorTitleAndSpecialty = specialty;
                                                });
                                            }}
                                            disableEdit
                                            isValid
                                            dataCy="contactDirectory-creatreEmployeeReferralSearch"
                                        />
                                    )}
                                    fallbackFeature={(
                                        <ReferalDoctorSearchAutocompleteCustom
                                            useblurevent={true}
                                            focusOnLoad={false}
                                            disabled={false}
                                            displayList={false}
                                            componentId="search_directory"
                                            selectedDoctors={null}
                                            selectionCallBack={(_, intervenor) => this.onSelectClinician(intervenor)}
                                            closeDropDownAfterSelection={true}
                                            changedTextValueCallback={text => this.onSearchTextChanged(text)}
                                        />
                                    )}
                                />
                            </div>
                        </div>

                        <div className="flex-container flex-row flex-start pad-top-10">

                            {this.getErrorMessages()}

                            {this.getLoadingComponent()}

                            {this.state.licencedIntervenorInfo != null && (
                                <div>
                                    <div className="flex-container flex-row flex-grow-1">
                                        <div className="flex-container flex-center flex-grow-1">
                                            <h3>
                                                {this.getIntervenorNameString()}
                                            </h3>
                                        </div>
                                    </div>
                                    <div className="flex-container flex-row flex-grow-1">
                                        <div className="psingle-column practice centered">
                                            <div className="tbc">
                                                <div>
                                                    <table>
                                                        <tbody>
                                                            <tr>
                                                                <td className="c1">
                                                                    {cacheStore.GetString("CorpsProfessionelLabel")}
                                                                </td>
                                                                <td className="c2">
                                                                    <strong>
                                                                        {(this.state.intervenorTitleAndSpecialty != null && this.state.intervenorTitleAndSpecialty != null)
                                                                            ? LicenceOrganisationRule.getOrganisationName(this.state.intervenorTitleAndSpecialty.licenceOrganisationRuleModel)
                                                                            : ""
                                                                        }
                                                                    </strong>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="c1">
                                                                    {cacheStore.GetString("DisciplineLabel")}
                                                                </td>
                                                                <td className="c2">
                                                                    <strong>
                                                                        {this.state.intervenorTitleAndSpecialty
                                                                            ? TitleAndSpecialtyModel.getSpecNameFromAnyLanguage(this.state.intervenorTitleAndSpecialty)
                                                                            : ""
                                                                        }
                                                                    </strong>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="c1">
                                                                    {cacheStore.GetString("DescriptionProfessionelLabel")}
                                                                </td>
                                                                <td className="c2">
                                                                    <strong>
                                                                        {(this.state.licencedIntervenorInfo != null && this.state.licencedIntervenorInfo.SpecialityDetails != null)
                                                                            ? this.state.licencedIntervenorInfo.SpecialityDetails
                                                                            : ""
                                                                        }
                                                                    </strong>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="c1">
                                                                    {cacheStore.GetString("lblAddress")}
                                                                </td>
                                                                <td className="c2">
                                                                    <strong>
                                                                        {(this.state.licencedIntervenorInfo != null && this.state.licencedIntervenorInfo.Address != null)
                                                                            ? this.state.licencedIntervenorInfo.Address
                                                                            : ""
                                                                        }
                                                                    </strong>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                <div className="p-footer flex-display flex-end">
                    <ButtonGroup>
                        <ButtonControl
                            className="btn btn-default"
                            onClick={() => this.closeReinitUserPopupClick()}
                            label={cacheStore.GetString("CancelLabel")}
                        />
                        <ButtonControl
                            className="btn btn-primary"
                            onClick={() => this.createClericalAccountClick()}
                            label={cacheStore.GetString("CreateClericalAccountLabel")}
                        />
                        <ButtonControl
                            className="btn btn-primary"
                            onClick={() => this.createClinicalAccountClick()}
                            label={cacheStore.GetString("CreateClinicalAccountLabel")}
                        />
                    </ButtonGroup>
                </div>
            </div>
        );
    }

    private closeReinitUserPopupClick(): void {
        sessionStore.dispatch(this.props.closePopupOperation);
    }

    private createClericalAccountClick(): void {
        sessionStore.dispatch(
            this.props.createClericalAccountOperation,
            {
                licencedIntervenorInfo: this.state.licencedIntervenorInfo,
                speciality: this.state.intervenorTitleAndSpecialty
            }
        );
    }

    private createClinicalAccountClick(): void {
        sessionStore.dispatch(
            this.props.createClinicalAccountOperation,
            {
                licencedIntervenorInfo: this.state.licencedIntervenorInfo,
                speciality: this.state.intervenorTitleAndSpecialty
            }
        );
    }

    private onSearchTextChanged(text: string): void {
        this.mutateState(s => { s.searchTerm = text; });
    }

    private onSelectClinician(selectedIntervenor: LicencedIntervenor): void {
        if (selectedIntervenor != null) {
            this.loadLicencedIntervenor(selectedIntervenor.Id);
        }
    }

    private loadLicencedIntervenor(selectedLicencedIntervenorId: string): void {
        this.mutateState(s => { s.isLoading = true; });

        Client.Post(
            ServerOperations.Server.MedfarDictionnary_LoadDoctorInfo,
            { LicencedIntervenorId: selectedLicencedIntervenorId },
            response => this.loadLicenceIntervenorSucess(response),
            err => this.onError(err)
        );
    }

    private loadLicenceIntervenorSucess(response: any): void {
        const intervenor = response.LicencedIntervenorInfo;
        if (intervenor != null) {
            const licenceOrganisationRule = cacheStore.LicenceOrganisationRulesById[intervenor.LicenceOrganisationRuleId];
            const licenceOrganisationSpecialisation = cacheStore.LicenseOrganizationSpecializationsById[intervenor.LicenceOrganisationSpecialisationId];
            this.mutateState(s => {
                s.licencedIntervenorInfo = intervenor;
                s.intervenorTitleAndSpecialty = new TitleAndSpecialtyModel(licenceOrganisationRule, licenceOrganisationSpecialisation);
            });
        }
    }

    private getIntervenorNameString(): string {
        let result = "";

        if (this.state.licencedIntervenorInfo != null) {
            if (this.state.licencedIntervenorInfo.LastName != null) result += this.state.licencedIntervenorInfo.LastName.toUpperCase() + ", ";
            if (this.state.licencedIntervenorInfo.FirstName != null) result += this.state.licencedIntervenorInfo.FirstName;
            if (this.state.licencedIntervenorInfo.LicenceNumber != null) result += (" - (" + this.state.licencedIntervenorInfo.LicenceNumber + ")");

            if (this.state.intervenorTitleAndSpecialty != null) {
                result += " - " + LicenceOrganisationRule.getTitleName(this.state.intervenorTitleAndSpecialty.licenceOrganisationRuleModel);
            }
        }

        return result;
    }

    private getLoadingComponent(): JSX.Element {
        if (this.state.isLoading && (this.state.errors == null || this.state.errors.length == 0))
            return <InformationLoadingComponent smallVersion={true} customMessage={cacheStore.GetString("WaitForPortalLabel")} />;

        return null;
    }

    private getErrorMessages(): JSX.Element {
        return <ErrorMessageComponent errors={this.state.errors} />;
    }

    private onError(error: string): void {
        this.mutateState(s => {
            s.isLoading = false;
            s.errors = [error];
        });
    }
}

export { CreateNewEmployeeComponent };
